/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteRouteImport } from './routes/_authed/route'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthRedeemRouteImport } from './routes/auth.redeem'
import { Route as AuthedUsersIndexRouteImport } from './routes/_authed/users/index'
import { Route as AuthedThinkTankIndexRouteImport } from './routes/_authed/think-tank/index'
import { Route as AuthedReportsIndexRouteImport } from './routes/_authed/reports/index'
import { Route as AuthedPromptsIndexRouteImport } from './routes/_authed/prompts/index'
import { Route as AuthedLlmsIndexRouteImport } from './routes/_authed/llms/index'
import { Route as AuthedIdeasIndexRouteImport } from './routes/_authed/ideas/index'
import { Route as AuthedCommandsIndexRouteImport } from './routes/_authed/commands/index'
import { Route as AuthedPromptsNewRouteImport } from './routes/_authed/prompts/new'
import { Route as AuthedLlmsNewRouteImport } from './routes/_authed/llms/new'
import { Route as AuthedLlmsIdRouteImport } from './routes/_authed/llms/$id'
import { Route as AuthedPromptsIdIndexRouteImport } from './routes/_authed/prompts/$id/index'
import { Route as AuthedPromptsIdVersionsVidRouteImport } from './routes/_authed/prompts/$id/versions/$vid'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthRedeemRoute = AuthRedeemRouteImport.update({
  id: '/auth/redeem',
  path: '/auth/redeem',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedUsersIndexRoute = AuthedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedThinkTankIndexRoute = AuthedThinkTankIndexRouteImport.update({
  id: '/think-tank/',
  path: '/think-tank/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedReportsIndexRoute = AuthedReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedPromptsIndexRoute = AuthedPromptsIndexRouteImport.update({
  id: '/prompts/',
  path: '/prompts/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedLlmsIndexRoute = AuthedLlmsIndexRouteImport.update({
  id: '/llms/',
  path: '/llms/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedIdeasIndexRoute = AuthedIdeasIndexRouteImport.update({
  id: '/ideas/',
  path: '/ideas/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedCommandsIndexRoute = AuthedCommandsIndexRouteImport.update({
  id: '/commands/',
  path: '/commands/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedPromptsNewRoute = AuthedPromptsNewRouteImport.update({
  id: '/prompts/new',
  path: '/prompts/new',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedLlmsNewRoute = AuthedLlmsNewRouteImport.update({
  id: '/llms/new',
  path: '/llms/new',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedLlmsIdRoute = AuthedLlmsIdRouteImport.update({
  id: '/llms/$id',
  path: '/llms/$id',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedPromptsIdIndexRoute = AuthedPromptsIdIndexRouteImport.update({
  id: '/prompts/$id/',
  path: '/prompts/$id/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedPromptsIdVersionsVidRoute =
  AuthedPromptsIdVersionsVidRouteImport.update({
    id: '/prompts/$id/versions/$vid',
    path: '/prompts/$id/versions/$vid',
    getParentRoute: () => AuthedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/auth/redeem': typeof AuthRedeemRoute
  '/llms/$id': typeof AuthedLlmsIdRoute
  '/llms/new': typeof AuthedLlmsNewRoute
  '/prompts/new': typeof AuthedPromptsNewRoute
  '/commands/': typeof AuthedCommandsIndexRoute
  '/ideas/': typeof AuthedIdeasIndexRoute
  '/llms/': typeof AuthedLlmsIndexRoute
  '/prompts/': typeof AuthedPromptsIndexRoute
  '/reports/': typeof AuthedReportsIndexRoute
  '/think-tank/': typeof AuthedThinkTankIndexRoute
  '/users/': typeof AuthedUsersIndexRoute
  '/prompts/$id/': typeof AuthedPromptsIdIndexRoute
  '/prompts/$id/versions/$vid': typeof AuthedPromptsIdVersionsVidRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/auth/redeem': typeof AuthRedeemRoute
  '/': typeof AuthedIndexRoute
  '/llms/$id': typeof AuthedLlmsIdRoute
  '/llms/new': typeof AuthedLlmsNewRoute
  '/prompts/new': typeof AuthedPromptsNewRoute
  '/commands': typeof AuthedCommandsIndexRoute
  '/ideas': typeof AuthedIdeasIndexRoute
  '/llms': typeof AuthedLlmsIndexRoute
  '/prompts': typeof AuthedPromptsIndexRoute
  '/reports': typeof AuthedReportsIndexRoute
  '/think-tank': typeof AuthedThinkTankIndexRoute
  '/users': typeof AuthedUsersIndexRoute
  '/prompts/$id': typeof AuthedPromptsIdIndexRoute
  '/prompts/$id/versions/$vid': typeof AuthedPromptsIdVersionsVidRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/auth/redeem': typeof AuthRedeemRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/llms/$id': typeof AuthedLlmsIdRoute
  '/_authed/llms/new': typeof AuthedLlmsNewRoute
  '/_authed/prompts/new': typeof AuthedPromptsNewRoute
  '/_authed/commands/': typeof AuthedCommandsIndexRoute
  '/_authed/ideas/': typeof AuthedIdeasIndexRoute
  '/_authed/llms/': typeof AuthedLlmsIndexRoute
  '/_authed/prompts/': typeof AuthedPromptsIndexRoute
  '/_authed/reports/': typeof AuthedReportsIndexRoute
  '/_authed/think-tank/': typeof AuthedThinkTankIndexRoute
  '/_authed/users/': typeof AuthedUsersIndexRoute
  '/_authed/prompts/$id/': typeof AuthedPromptsIdIndexRoute
  '/_authed/prompts/$id/versions/$vid': typeof AuthedPromptsIdVersionsVidRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/auth/redeem'
    | '/llms/$id'
    | '/llms/new'
    | '/prompts/new'
    | '/commands/'
    | '/ideas/'
    | '/llms/'
    | '/prompts/'
    | '/reports/'
    | '/think-tank/'
    | '/users/'
    | '/prompts/$id/'
    | '/prompts/$id/versions/$vid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/auth/redeem'
    | '/'
    | '/llms/$id'
    | '/llms/new'
    | '/prompts/new'
    | '/commands'
    | '/ideas'
    | '/llms'
    | '/prompts'
    | '/reports'
    | '/think-tank'
    | '/users'
    | '/prompts/$id'
    | '/prompts/$id/versions/$vid'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/auth/redeem'
    | '/_authed/'
    | '/_authed/llms/$id'
    | '/_authed/llms/new'
    | '/_authed/prompts/new'
    | '/_authed/commands/'
    | '/_authed/ideas/'
    | '/_authed/llms/'
    | '/_authed/prompts/'
    | '/_authed/reports/'
    | '/_authed/think-tank/'
    | '/_authed/users/'
    | '/_authed/prompts/$id/'
    | '/_authed/prompts/$id/versions/$vid'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthRedeemRoute: typeof AuthRedeemRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/auth/redeem': {
      id: '/auth/redeem'
      path: '/auth/redeem'
      fullPath: '/auth/redeem'
      preLoaderRoute: typeof AuthRedeemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/users/': {
      id: '/_authed/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthedUsersIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/think-tank/': {
      id: '/_authed/think-tank/'
      path: '/think-tank'
      fullPath: '/think-tank/'
      preLoaderRoute: typeof AuthedThinkTankIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/reports/': {
      id: '/_authed/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthedReportsIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/prompts/': {
      id: '/_authed/prompts/'
      path: '/prompts'
      fullPath: '/prompts/'
      preLoaderRoute: typeof AuthedPromptsIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/llms/': {
      id: '/_authed/llms/'
      path: '/llms'
      fullPath: '/llms/'
      preLoaderRoute: typeof AuthedLlmsIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/ideas/': {
      id: '/_authed/ideas/'
      path: '/ideas'
      fullPath: '/ideas/'
      preLoaderRoute: typeof AuthedIdeasIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/commands/': {
      id: '/_authed/commands/'
      path: '/commands'
      fullPath: '/commands/'
      preLoaderRoute: typeof AuthedCommandsIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/prompts/new': {
      id: '/_authed/prompts/new'
      path: '/prompts/new'
      fullPath: '/prompts/new'
      preLoaderRoute: typeof AuthedPromptsNewRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/llms/new': {
      id: '/_authed/llms/new'
      path: '/llms/new'
      fullPath: '/llms/new'
      preLoaderRoute: typeof AuthedLlmsNewRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/llms/$id': {
      id: '/_authed/llms/$id'
      path: '/llms/$id'
      fullPath: '/llms/$id'
      preLoaderRoute: typeof AuthedLlmsIdRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/prompts/$id/': {
      id: '/_authed/prompts/$id/'
      path: '/prompts/$id'
      fullPath: '/prompts/$id/'
      preLoaderRoute: typeof AuthedPromptsIdIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/prompts/$id/versions/$vid': {
      id: '/_authed/prompts/$id/versions/$vid'
      path: '/prompts/$id/versions/$vid'
      fullPath: '/prompts/$id/versions/$vid'
      preLoaderRoute: typeof AuthedPromptsIdVersionsVidRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
  }
}

interface AuthedRouteRouteChildren {
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedLlmsIdRoute: typeof AuthedLlmsIdRoute
  AuthedLlmsNewRoute: typeof AuthedLlmsNewRoute
  AuthedPromptsNewRoute: typeof AuthedPromptsNewRoute
  AuthedCommandsIndexRoute: typeof AuthedCommandsIndexRoute
  AuthedIdeasIndexRoute: typeof AuthedIdeasIndexRoute
  AuthedLlmsIndexRoute: typeof AuthedLlmsIndexRoute
  AuthedPromptsIndexRoute: typeof AuthedPromptsIndexRoute
  AuthedReportsIndexRoute: typeof AuthedReportsIndexRoute
  AuthedThinkTankIndexRoute: typeof AuthedThinkTankIndexRoute
  AuthedUsersIndexRoute: typeof AuthedUsersIndexRoute
  AuthedPromptsIdIndexRoute: typeof AuthedPromptsIdIndexRoute
  AuthedPromptsIdVersionsVidRoute: typeof AuthedPromptsIdVersionsVidRoute
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedLlmsIdRoute: AuthedLlmsIdRoute,
  AuthedLlmsNewRoute: AuthedLlmsNewRoute,
  AuthedPromptsNewRoute: AuthedPromptsNewRoute,
  AuthedCommandsIndexRoute: AuthedCommandsIndexRoute,
  AuthedIdeasIndexRoute: AuthedIdeasIndexRoute,
  AuthedLlmsIndexRoute: AuthedLlmsIndexRoute,
  AuthedPromptsIndexRoute: AuthedPromptsIndexRoute,
  AuthedReportsIndexRoute: AuthedReportsIndexRoute,
  AuthedThinkTankIndexRoute: AuthedThinkTankIndexRoute,
  AuthedUsersIndexRoute: AuthedUsersIndexRoute,
  AuthedPromptsIdIndexRoute: AuthedPromptsIdIndexRoute,
  AuthedPromptsIdVersionsVidRoute: AuthedPromptsIdVersionsVidRoute,
}

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthRedeemRoute: AuthRedeemRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
